// extracted by mini-css-extract-plugin
module.exports = {"axis":"ProjectDepartmentsHistory_axis_qP8Nj","y":"ProjectDepartmentsHistory_y_2-nj3","x":"ProjectDepartmentsHistory_x_1MHQF","chart":"ProjectDepartmentsHistory_chart_3W_4i"};